var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useDynamicBoolean } from '@doordash/component-dynamic-values';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { PORTAL_ROUTE_PREFIX } from '../constants/values';
import { DYNAMIC_VALUES_NAME } from './DynamicValues';
import { Icon, Colors, Spacing } from '@doordash/design-language';
import { getTeamId } from '../selectors/portal_selector';
import { getSelectedTeamAccountContent } from '../selectors/uiSelector';
import { AdminPageSidebarStyle } from './AdminPage/AdminPageStyles';
import { AdminPageSidebarTestId } from './testId';
import { EXPENSED_MEALS_STATUS } from '../types/expensed_meal';
import { GRAY_100 } from './Styles/constants';
import { DASHPASS_STATUS } from '../types/dashpass';
var SidebarIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  margin-right: ", "px;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  margin-right: ", "px;\n"])), Spacing.Large, Spacing.Large, Spacing.Small);
var SidebarNavMenuItem = styled(NavLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", "px;\n  background-color: ", ";\n  color: ", ";\n  border-left: ", "px solid ", ";\n  font-weight: 700;\n  margin-right: 0;\n  &.active-menu-item {\n    color: ", ";\n    background-color: ", ";\n    border-left: ", "px solid ", ";\n    font-weight: 700;\n    & > svg > * {\n      fill: ", ";\n    }\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", "px;\n  background-color: ", ";\n  color: ", ";\n  border-left: ", "px solid ", ";\n  font-weight: 700;\n  margin-right: 0;\n  &.active-menu-item {\n    color: ", ";\n    background-color: ", ";\n    border-left: ", "px solid ", ";\n    font-weight: 700;\n    & > svg > * {\n      fill: ", ";\n    }\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), Spacing.Small, Colors.SystemWhite, Colors.SystemBlack, Spacing.XxxSmall, Colors.SystemWhite, Colors.SystemRed60, Colors.ButtonSecondaryBackgroundHovered, Spacing.XxxSmall, Colors.SystemRed60, Colors.SystemRed60, Colors.ButtonSecondaryBackgroundHovered, Colors.SystemRed60, GRAY_100, Colors.SystemBlack);
export var shouldShowExpensedMealsSpecificMenuItem = function (teamAcc, options) {
    var _a;
    if (!options.hideExpensedMealsDvRolledOut) {
        return true;
    }
    var noExpensedMealsForSelectedAccount = !!(((_a = teamAcc === null || teamAcc === void 0 ? void 0 : teamAcc.expensedMeals) === null || _a === void 0 ? void 0 : _a.status) === EXPENSED_MEALS_STATUS.INACTIVE);
    return !noExpensedMealsForSelectedAccount;
};
export var shouldShowMealBudgetsUnsubscribedMenuItem = function (teamAcc, options) {
    var _a;
    var hasExpensedMealsForSelectedAccount = !!(((_a = teamAcc === null || teamAcc === void 0 ? void 0 : teamAcc.expensedMeals) === null || _a === void 0 ? void 0 : _a.status) === EXPENSED_MEALS_STATUS.ACTIVE);
    return (options.hideExpensedMealsDvRolledOut &&
        !options.hideDashPassForLegacyDashPassAccounts &&
        !hasExpensedMealsForSelectedAccount);
};
export var shouldShowDashPassMenu = function (teamAcc, options) {
    if (options.hideExpensedMealsDvRolledOut &&
        !options.hideDashPassForLegacyDashPassAccounts) {
        return true;
    }
    return false;
};
export var shouldShowDashPassSubscribedMenu = function (teamAcc, options) {
    var _a;
    var isDashPassActive = ((_a = teamAcc === null || teamAcc === void 0 ? void 0 : teamAcc.dashPass) === null || _a === void 0 ? void 0 : _a.status) ===
        DASHPASS_STATUS.TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_ACTIVE;
    return shouldShowDashPassMenu(teamAcc, options) && isDashPassActive;
};
export var shouldShowDashPassUnSubscribedMenu = function (teamAcc, options) {
    var _a;
    var isDashPassInActive = ((_a = teamAcc === null || teamAcc === void 0 ? void 0 : teamAcc.dashPass) === null || _a === void 0 ? void 0 : _a.status) ===
        DASHPASS_STATUS.TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_INACTIVE;
    return shouldShowDashPassMenu(teamAcc, options) && isDashPassInActive;
};
var sidebarMenuItems = [
    {
        text: 'Employees',
        id: 'employees',
        subpageRoute: '/members',
        icon: (React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.PeopleAddLine, useDefaultColors: true })),
        shouldShow: function () { return true; },
    },
    {
        id: 'dashpassSubscribed',
        subpageRoute: '/dashpass',
        icon: (React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.LogoDashpassNew })),
        text: 'DashPass',
        shouldShow: shouldShowDashPassSubscribedMenu,
    },
    {
        text: 'Groups',
        id: 'groups',
        subpageRoute: '/groups',
        icon: (React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.PeopleGroupLine, useDefaultColors: true })),
        shouldShow: shouldShowExpensedMealsSpecificMenuItem,
    },
    {
        text: 'Payment Methods',
        id: 'billings',
        subpageRoute: '/billing',
        icon: React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.CardLine }),
        shouldShow: shouldShowExpensedMealsSpecificMenuItem,
    },
    {
        id: 'budgetsSubscribed',
        subpageRoute: '/budgets',
        icon: (React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.MoneyCircleLine })),
        text: 'Meal Budgets',
        shouldShow: shouldShowExpensedMealsSpecificMenuItem,
    },
    {
        id: 'order-history',
        subpageRoute: '/order-history',
        icon: (React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.TimeLine, useDefaultColors: true })),
        text: 'Order History',
        shouldShow: shouldShowExpensedMealsSpecificMenuItem,
    },
    {
        id: 'dashpassUnSubscribed',
        subpageRoute: '/dashpass',
        icon: (React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.LogoDashpassNew })),
        text: 'Add DashPass',
        shouldShow: shouldShowDashPassUnSubscribedMenu,
    },
    {
        id: 'budgetsUnSubscribed',
        subpageRoute: '/budgets',
        icon: (React.createElement(SidebarIcon, { size: Icon.Sizes.Medium, type: Icon.Types.MoneyCircleLine })),
        text: 'Add Expensed Meals',
        shouldShow: shouldShowMealBudgetsUnsubscribedMenuItem,
    },
];
var AdminPageSidebar = function (props) {
    var teamId = useSelector(getTeamId) || '';
    var selectedTeamAccount = useSelector(getSelectedTeamAccountContent);
    var hideExpensedMealsDvRolledOut = useDynamicBoolean(DYNAMIC_VALUES_NAME.dashPassForWorkOnboarding, {
        teamId: teamId,
    });
    var isInHideDV1 = useDynamicBoolean(DYNAMIC_VALUES_NAME.ddfwDisableWorkPortalDashPass_1, {
        teamId: teamId,
    });
    var isInHideDV2 = useDynamicBoolean(DYNAMIC_VALUES_NAME.ddfwDisableWorkPortalDashPass_2, {
        teamId: teamId,
    });
    var hideDashPassForLegacyDashPassAccounts = isInHideDV1 || isInHideDV2;
    return (React.createElement(AdminPageSidebarStyle, { "data-testid": AdminPageSidebarTestId.AdminPageSideBar }, sidebarMenuItems.map(function (menuItem) {
        if (!selectedTeamAccount) {
            return null;
        }
        var shouldShow = menuItem.shouldShow(selectedTeamAccount, {
            hideExpensedMealsDvRolledOut: hideExpensedMealsDvRolledOut,
            hideDashPassForLegacyDashPassAccounts: hideDashPassForLegacyDashPassAccounts,
        });
        return shouldShow ? (React.createElement(SidebarNavMenuItem, { "data-testid": AdminPageSidebarTestId.AdminPageSideBarMenuItem, key: menuItem.id, activeClassName: 'active-menu-item', to: PORTAL_ROUTE_PREFIX + "/admin/" + props.teamAccountId + menuItem.subpageRoute },
            menuItem.icon,
            menuItem.text)) : null;
    })));
};
export default AdminPageSidebar;
var templateObject_1, templateObject_2;
